import * as React from 'react';

type Theme = 'light' | 'dark' | 'system';

const STORAGE_KEY = 'gainsignal-theme';

const readStoredTheme = (): Theme => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === 'light' || stored === 'dark' ? stored : 'system';
  } catch {
    // Private windows and blocked site data throw on access.
    return 'system';
  }
};

/**
 * `system` removes both classes and lets the media query in index.css decide, so
 * following the OS needs no listener and no re-render.
 */
export const useTheme = () => {
  const [theme, setThemeState] = React.useState<Theme>(readStoredTheme);

  React.useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('light', 'dark');

    if (theme !== 'system') {
      root.classList.add(theme);
    }

    try {
      if (theme === 'system') {
        localStorage.removeItem(STORAGE_KEY);
      } else {
        localStorage.setItem(STORAGE_KEY, theme);
      }
    } catch {
      // Preference simply does not persist. Not worth failing a render over.
    }
  }, [theme]);

  return { theme, setTheme: setThemeState };
};
